import { useCallback } from 'react';
import { Message } from '../../../types/chat';
import { createUserMessage, createInitialAssistantMessage } from '../utils/messageFormatters';

interface UseMessageUpdaterProps {
    setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
    currentAssistantMessage: React.RefObject<string>;
}

export const useMessageUpdater = ({
    setMessages,
    currentAssistantMessage,
}: UseMessageUpdaterProps) => {
    // 添加新消息
    const addMessage = useCallback((message: Message) => {
        setMessages(prev => [...prev, message]);
    }, [setMessages]);

    // 添加用户消息
    const addUserMessage = useCallback((text: string) => {
        addMessage(createUserMessage(text));
    }, [addMessage]);

    // 添加初始助手消息
    const addInitialAssistantMessage = useCallback((id: string) => {
        addMessage(createInitialAssistantMessage(id));
        currentAssistantMessage.current = '';
    }, [addMessage, currentAssistantMessage]);

    // 更新消息列表
    const updateMessages = useCallback((messages: Message[]) => {
        setMessages(messages);
    }, [setMessages]);

    // 更新指定消息
    const updateMessageById = useCallback((id: string, updates: Partial<Message>) => {
        setMessages((prev: Message[]) => prev.map(msg => {
            if (msg.id === id) {
                // 合并原有消息和更新内容
                return { ...msg, ...updates } as Message;
            }
            return msg;
        }));
    }, [setMessages]);

    // 添加历史消息
    const addHistoryMessages = useCallback((messages: Message[], append: boolean = false) => {
        if (append) {
            setMessages(prev => [...messages, ...prev]);
        } else {
            setMessages(messages);
        }
    }, [setMessages]);

    return {
        addMessage,
        addUserMessage,
        addInitialAssistantMessage,
        updateMessages,
        updateMessageById,
        addHistoryMessages,
    };
};